import r from "./ghl-ui.es728.js";
var t = r.Uint8Array;
const o = t;
export {
  o as default
};
